import { MenuIcon } from '@/components/Icons';
import OrganizationPickerModal from '@/components/OrganizationPickerModal/OrganizationPickerModal';
import useFloatingMenu from '@/hooks/use-floating-menu.hook';
import { useGetCurrentUser } from '@/modules/Users/queries';
import { goToJiraMakeRequestLink } from '@/shared/utils/jira-links';
import { FloatingPortal } from '@floating-ui/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

export const Menu = () => {
  const { t } = useTranslation();
  const [isOrganizationPickerOpen, setIsOrganizationPickerOpen] =
    useState(false);
  const { data: user } = useGetCurrentUser();
  const { isOpen, refs, floatingStyles, getFloatingProps, getReferenceProps } =
    useFloatingMenu();
  const auth = useAuth();

  const options = useMemo(() => {
    const organizationsCount = user?.organizations?.length ?? 0;
    return [
      {
        label: t('menu_make_request'),
        action: goToJiraMakeRequestLink,
      },
      ...(organizationsCount > 1
        ? [
            {
              label: t('change_organization'),
              action: () => {
                setIsOrganizationPickerOpen(true);
              },
            },
          ]
        : []),
      {
        label: t('menu_logout'),
        action: () => {
          auth.signoutSilent();
        },
      },
    ];
  }, [auth, t, user?.organizations?.length]);

  return (
    <>
      <div ref={refs.setReference} {...getReferenceProps()}>
        <div className="cursor-pointer">
          <MenuIcon />
        </div>
        {isOpen && (
          <FloatingPortal>
            <div
              ref={refs.setFloating}
              style={floatingStyles}
              {...getFloatingProps()}
              className="flex w-56 flex-col divide-y rounded bg-white p-1 shadow-custom"
            >
              {options.map((option, index) => (
                <div
                  key={index}
                  className="cursor-pointer p-2.5 text-sm font-black"
                  onClick={option.action}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </FloatingPortal>
        )}
      </div>
      <OrganizationPickerModal
        isOpen={isOrganizationPickerOpen}
        onClose={() => setIsOrganizationPickerOpen(false)}
      />
    </>
  );
};
